import Api from "../../../Services/Api";
import { fetchDataAsync } from "../../../Services/Utils";
import { HttpStatus } from "../../common/Constants";
import { mapToObjectDDL } from "../../common/mapper";
import {
  FAKTUR_JUAL_BENGKEL_KATEGORI,
  INITIAL_SAVED_ROW,
  JENIS_PIT_OPTIONS,
  TIPE_FJB_OPTIONS,
  TIPE_PEMBAYARAN_NON_TUNAI_OPTIONS,
  TIPE_PEMBAYARAN_OPTIONS,
} from "./constant";
import {
  countAfterDiscount,
  countBeforeDiscount,
  countDiscount,
} from "./utils";

const parseDataHeader = (dataHeader, tab, kodeCabang) => {
  return {
    kodeCabang:
      tab === "DGI" && !dataHeader?.cabang
        ? kodeCabang
        : mapToObjectDDL(
            dataHeader?.cabang?.namaDealer,
            dataHeader?.cabang?.kodeCabang
          ),
    kategoriFakturJualBengkel: FAKTUR_JUAL_BENGKEL_KATEGORI?.find(
      (item) => item.value === dataHeader?.category
    ),
    jenisProspect: dataHeader?.jenisProspect || null,
    noBooking: dataHeader?.nomorBooking,
    claimNo: dataHeader?.nomorClaim,
    noFakturJualBengkel: dataHeader?.nomorFakturJualBengkel,
    noHotline: dataHeader?.nomorHotline,
    noProspect: dataHeader?.nomorProspect,
    tanggalFakturJualBengkel: dataHeader?.tanggalFakturJualBengkel,
    tipeFjb: TIPE_FJB_OPTIONS?.find(
      (item) => item?.value === dataHeader?.tipeFJB
    ),
    mekanikSebelumnya: dataHeader?.mekanikSebelumnya
      ? mapToObjectDDL(
          dataHeader?.mekanikSebelumnya.name,
          dataHeader?.mekanikSebelumnya.name.employeeId
        )
      : null,
    fjbSource: dataHeader?.fjbSource,
    listIdPelanggaran: dataHeader?.idPelanggaranList,
  };
};

const parseDataUnit = (dtUnit) => {
  return {
    noPolisi: dtUnit?.noPolisi,
    noRangka: dtUnit?.noRangka,
    noMesin: dtUnit?.noMesin,
    kodeVarian: {
      label: dtUnit?.variantDTO?.kodeVariant,
      value: dtUnit?.variantDTO?.kodeVariant,
    },
    namaVarian: dtUnit?.variantDTO?.namaVariant,
    tahunMotor: dtUnit?.tahunMotor,
    informasiBensin: dtUnit?.informasiBensin,
    kmTerakhir: dtUnit?.kmTerakhir,
  };
};

const parseDataPersonal = (dtPemilik, tab, type) => {
  const kota = tab === "NOS" ? "kabKot" : "kota";
  const key = type === "pemilik" ? "isCompany" : "isBuyer";
  const value = type === "pemilik" ? "perusahaan" : "pemilik";
  return {
    name: dtPemilik?.nama,
    nik: dtPemilik?.nik,
    hpNumber1: dtPemilik?.noHp1,
    hpNumber2: dtPemilik?.noHp2,
    email: dtPemilik?.email,
    address: dtPemilik?.alamat,
    kkNumber: dtPemilik?.noKK,
    npwp: dtPemilik?.npwp,
    province: dtPemilik?.provinsi
      ? mapToObjectDDL(
          dtPemilik?.provinsi?.provinceName,
          dtPemilik?.provinsi?.id
        )
      : null,
    kabkot: dtPemilik?.[kota]
      ? mapToObjectDDL(
          dtPemilik?.[kota]?.kabKotName,
          dtPemilik?.[kota]?.kabKotId
        )
      : null,
    kecamatan: mapToObjectDDL(
      dtPemilik?.kecamatan?.kecamatanName,
      dtPemilik?.kecamatan?.id
    ),
    kelurahan: dtPemilik?.kelurahan
      ? mapToObjectDDL(
          dtPemilik?.kelurahan?.kelurahanname,
          dtPemilik?.kelurahan?.id
        )
      : null,
    zipCode: dtPemilik?.kodePos
      ? mapToObjectDDL(dtPemilik?.kodePos, dtPemilik?.kodePos)
      : null,
    gender: dtPemilik?.jenisKelamin
      ? mapToObjectDDL(dtPemilik.jenisKelamin.value, dtPemilik.jenisKelamin.key)
      : null,
    job1: dtPemilik?.pekerjaan1
      ? mapToObjectDDL(dtPemilik?.pekerjaan1?.value, dtPemilik?.pekerjaan1?.key)
      : null,
    job2: dtPemilik?.pekerjaan2
      ? mapToObjectDDL(dtPemilik?.pekerjaan2?.value, dtPemilik?.pekerjaan2?.key)
      : null,
    religion: dtPemilik?.agama
      ? mapToObjectDDL(dtPemilik?.agama?.value, dtPemilik?.agama?.key)
      : null,
    memberId: dtPemilik?.memberId,
    memberLevel: dtPemilik?.memberLevel,
    loyaltyLvl: dtPemilik?.loyaltyLevel,
    facebook: dtPemilik?.facebook,
    instagram: dtPemilik?.instagram,
    linkedin: dtPemilik?.linkedin,
    x: dtPemilik?.x,
    [key]: dtPemilik?.[value],
    tiktok: dtPemilik?.tiktok,
    hobby: dtPemilik?.hobby
      ? mapToObjectDDL(dtPemilik?.hobby?.value, dtPemilik?.hobby?.key)
      : null,
    interest: dtPemilik?.interest
      ? mapToObjectDDL(dtPemilik?.interest?.value, dtPemilik?.interest?.key)
      : null,
  };
};

const parseDataTambahan = (dtTambahan, tab, defaultAdminFjb) => {
  return {
    noWorkOrder: dtTambahan?.noWorkOrder,
    tanggalService: dtTambahan?.tanggalService,
    waktuPkb: dtTambahan?.waktuPkb || dtTambahan?.waktuPKB,
    asalUnitEntry: mapToObjectDDL(
      dtTambahan?.asalUnitEntry?.value,
      dtTambahan?.asalUnitEntry?.key
    ),
    mekanik: mapToObjectDDL(
      dtTambahan?.namaMekanik?.name,
      dtTambahan?.namaMekanik?.id
    ),
    finalCheck: mapToObjectDDL(
      dtTambahan?.finalCheck?.name,
      dtTambahan?.finalCheck?.id
    ),
    jenisPit: JENIS_PIT_OPTIONS?.find(
      (item) => item.value === dtTambahan?.jenisPit
    ),
    waktuPendaftaran: dtTambahan?.waktuPendaftaran,
    waktuSelesai: dtTambahan?.waktuSelesai,
    totalFrt: tab === "DGI" ? dtTambahan?.totalFrt : dtTambahan?.totalFRT,
    sa: mapToObjectDDL(dtTambahan?.sa?.name, dtTambahan?.sa?.id),
    adminFjb: dtTambahan?.adminFJB
      ? mapToObjectDDL(dtTambahan?.adminFJB?.name, dtTambahan?.adminFJB?.id)
      : defaultAdminFjb,
  };
};

const parseDataTransaksi = (dtTransaksi, tab, isSo) => {
  const qr = dtTransaksi?.partDenganQr?.map((item) => ({
    ...item,
    kodePart: mapToObjectDDL(item.kodePart, item.kodePart),
    namaPart: mapToObjectDDL(item.namaPart, item.kodePart),
    qtyPart: item?.qtyPart || 1,
    qtyStock: item?.qtyStock || 0,
    hargaSatuanSistem: item?.hargaSatuanSistem || 0,
    hargaDiberikan:
      tab === "DGI" || isSo
        ? item?.hargaSatuanSistem || 0
        : item?.hargaDiberikan || 0,
    diskonSistem: item?.diskonSistem || 0,
    diskonDiberikan: item?.diskonDiberikan || 0,
    diskonSistemCurrency: item?.diskonSistemCurrency || 0,
    diskonDiberikanCurrency: item?.diskonDiberikanCurrency || 0,
    qrCode: item.partQrCode,
    ...(tab === "DGI"
      ? { totalHarga: item?.hargaSatuanSistem * item?.qtyPart }
      : { totalHarga: item?.totalHarga === null ? ((item?.qtyPart || 1) * item?.hargaSatuanSistem) : item?.totalHarga}),
    ...INITIAL_SAVED_ROW,
    isSaved: true,
  }));
  
  const nonQr = dtTransaksi?.partTanpaQr?.map((item) => ({
    ...item,
    kodePart: mapToObjectDDL(item.kodePart, item.kodePart),
    namaPart: mapToObjectDDL(item.namaPart, item.kodePart),
    hargaSatuanSistem: item?.hargaSatuanSistem || 0,
    qtyPart: item?.qtyPart || 1,
    hargaDiberikan:
      tab === "DGI" || isSo
        ? item?.hargaSatuanSistem || 0
        : item?.hargaDiberikan || 0,
    diskonSistem: item?.diskonSistem || 0,
    diskonDiberikan: item?.diskonDiberikan || 0,
    diskonSistemCurrency: item?.diskonSistemCurrency || 0,
    diskonDiberikanCurrency: item?.diskonDiberikanCurrency || 0,
    ...(tab === "DGI"
      ? { totalHarga: item?.hargaSatuanSistem * item?.qtyPart }
      : { totalHarga: item?.totalHarga === null ? ((item?.qtyPart || 1) * item?.hargaSatuanSistem) : item?.totalHarga}),
    ...INITIAL_SAVED_ROW,
    isSaved: true,
  }));

  const part = [...nonQr, ...qr];

  const job = dtTransaksi?.jasaBengkel?.map((item) => ({
    ...item,
    kodeJasa: mapToObjectDDL(item.kodeJasa, item.kodeJasa),
    namaJasa: mapToObjectDDL(item.namaJasa, item.kodeJasa),
    serviceCategory: mapToObjectDDL(item?.kategoryServis, item?.kategoryServis),
    hargaSatuanSistem: item?.hargaSatuanSistem || 0,
    hargaDiberikan:
      tab === "DGI" || isSo
        ? item?.hargaSatuanSistem || 0
        : item?.hargaDiberikan || 0,
    diskonSistem: item?.diskonSistem || 0,
    diskonDiberikan: item?.diskonDiberikan || 0,
    diskonSistemCurrency: item?.diskonSistemCurrency || 0,
    diskonDiberikanCurrency: item?.diskonDiberikanCurrency || 0,
    ...(tab === "DGI"
      ? { totalHarga: item?.hargaSatuanSistem * item?.qtyPart }
      : {}),
    ...INITIAL_SAVED_ROW,
    isSaved: true,
  }));

  return {
    locator: !dtTransaksi?.dataLokator
      ? null
      : mapToObjectDDL(
          dtTransaksi?.dataLokator?.nameLocation,
          dtTransaksi?.dataLokator?.kodeLocation
        ),
    paket: dtTransaksi.dataPaket
      ? {
          label: dtTransaksi.dataPaket.packageName,
          value: dtTransaksi.dataPaket.packageId,
          ...dtTransaksi.dataPaket,
        }
      : null,
    tipePromo: dtTransaksi.isPromoOrVoucher || null,
    promoId: dtTransaksi.dataPromo?.promoServicePartId || null,
    namaPromo: dtTransaksi.dataPromo
      ? {
          label: dtTransaksi.dataPromo.promoServicePartName,
          value: dtTransaksi.dataPromo.promoServicePartId,
          id: dtTransaksi.dataPromo.id,
        }
      : null,

    kodeVoucher: null,

    tipePembayaran:
      TIPE_PEMBAYARAN_OPTIONS?.find(
        (item) => item?.value === dtTransaksi?.tipePembayaran
      )?.value || TIPE_PEMBAYARAN_OPTIONS[0]?.value,

    tipePembayaranNonTunai: dtTransaksi?.tipeTransfer
      ? TIPE_PEMBAYARAN_NON_TUNAI_OPTIONS.find(
          (item) => item.value === dtTransaksi?.tipeTransfer
        )
      : null,

    kodeBank: dtTransaksi.dataBank
      ? {
          label: `${dtTransaksi.dataBank.bankName} - ${dtTransaksi.dataBank.accountNumber}`,
          value: dtTransaksi?.dataBank?.id,
        }
      : null,
    totalJasaSebelumDiskon: countBeforeDiscount(job),
    totalJasaSesudahDiskon: countAfterDiscount(job),
    totalJasaDiskon: countDiscount(job),
    totalEstimasiWaktu: job?.reduce(
      (prev, curr) => prev + Number(curr.estimasiWaktu),
      0
    ),

    totalPartSebelumDiskon: countBeforeDiscount(part, "part"),
    totalPartSesudahDiskon: countAfterDiscount(part),
    totalPartDiskon: countDiscount(part),
    totalTitipanHotlin: null,
    totalKelebihanKekurangan: null,

    dataJob: job,
    dataPartQR: qr,
    dataPartNonQR: nonQr,
  };
};

export const getFjbDetail = async (value) => {
  const { setError, selectedData, tab, kodeCabang, defaultAdminFjb } = value;
  let data = {};
  let error = {};

  let header = {};
  let dataUnit = {};
  let dataPembawa = {};
  let dataPemilik = {};
  let dataAnalisa = {};
  let dataTransaksi = {};
  let dataTambahan = {};
  let dataKeterangan = {};

  const promises =
    tab === "DGI"
      ? [
          fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_DGI").getHeaderFJBDgi,
            menuName: "Faktur Jual Bengkel - DGI",
            setError,
            args: {
              id: selectedData?.id,
            },
          }),
          fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_DGI").getTabDataUnitDgi,
            menuName: "Faktur Jual Bengkel - DGI",
            setError,
            args: {
              noWO: selectedData?.workOrderId,
            },
          }),
          fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_DGI").getTabDataPemilikDgi,
            menuName: "Faktur Jual Bengkel - DGI",
            setError,
            args: {
              noWO: selectedData?.workOrderId,
            },
          }),
          fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_DGI").getTabDataPembawaDgi,
            menuName: "Faktur Jual Bengkel - DGI",
            setError,
            args: {
              noWO: selectedData?.workOrderId,
            },
          }),
          fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_DGI").getTabDataAnalisaDgi,
            menuName: "Faktur Jual Bengkel - DGI",
            setError,
            args: {
              noWO: selectedData?.workOrderId,
            },
          }),
          fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_DGI").getTabDataTransaksiDgi,
            menuName: "Faktur Jual Bengkel - DGI",
            setError,
            args: {
              noWO: selectedData?.workOrderId,
              kodeCabang: kodeCabang?.value,
            },
          }),
          fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_DGI").getTabDataTambahanDgi,
            menuName: "Faktur Jual Bengkel - DGI",
            setError,
            args: {
              noWO: selectedData?.workOrderId,
            },
          }),
          fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_DGI").getTabDataKeteranganDgi,
            menuName: "Faktur Jual Bengkel - DGI",
            setError,
            args: {
              noWO: selectedData?.workOrderId,
            },
          }),
        ]
      : [
          fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getHeaderFjbNos,
            menuName: "Faktur Jual Bengkel - NOS",
            setError,
            args: {
              id: selectedData?.id,
            },
          }),
          fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getTabDataUnitNos,
            menuName: "Faktur Jual Bengkel - NOS",
            setError,
            args: {
              orderServicePartId: selectedData?.nomorFJB,
            },
          }),
          fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getTabDataPemilikNos,
            menuName: "Faktur Jual Bengkel - NOS",
            setError,
            args: {
              orderServicePartId: selectedData?.nomorFJB,
            },
          }),
          fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getTabDataPembawaNos,
            menuName: "Faktur Jual Bengkel - NOS",
            setError,
            args: {
              orderServicePartId: selectedData?.nomorFJB,
            },
          }),
          fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getTabDataAnalisaNos,
            menuName: "Faktur Jual Bengkel - NOS",
            setError,
            args: {
              orderServicePartId: selectedData?.nomorFJB,
            },
          }),
          fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getTabTransaksiNos,
            menuName: "Faktur Jual Bengkel - NOS",
            setError,
            args: {
              orderServicePartId: selectedData?.nomorFJB,
            },
          }),
          fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getTabTambahanNos,
            menuName: "Faktur Jual Bengkel - NOS",
            setError,
            args: {
              orderServicePartId: selectedData?.nomorFJB,
            },
          }),
          fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getTabKeteranganNos,
            menuName: "Faktur Jual Bengkel - NOS",
            setError,
            args: {
              orderServicePartId: selectedData?.nomorFJB,
            },
          }),
        ];

  const res = await Promise.all(promises);

  if (res[0].ok && res[0].data.status === HttpStatus.SUCCESS) {
    header = parseDataHeader(res[0].data.data, tab, kodeCabang);
  }

  if (res[1].ok && res[1].data.status === HttpStatus.SUCCESS) {
    dataUnit = parseDataUnit(res[1].data.data);
  }

  if (res[2].ok && res[2].data.status === HttpStatus.SUCCESS) {
    dataPemilik = parseDataPersonal(res[2].data.data, tab, "pemilik");
  }

  if (res[3].ok && res[3].data.status === HttpStatus.SUCCESS) {
    dataPembawa = parseDataPersonal(res[3].data.data, tab, "pembawa");
  }

  if (res[4].ok && res[4].data.status === HttpStatus.SUCCESS) {
    const dtAnalisa = res[4].data.data;
    dataAnalisa = {
      rekomendasiSa: dtAnalisa?.rekomendasiSa,
      keluhanKonsumen: dtAnalisa?.keluhanKonsumen,
    };
  }

  if (res[5].ok && res[5].data.status === HttpStatus.SUCCESS) {
    const isSo = res?.[0]?.data?.data?.fjbSource === "STOCK_OPNAME";
    dataTransaksi = parseDataTransaksi(res[5].data.data, tab, isSo);
  }

  if (res[6].ok && res[6].data.status === HttpStatus.SUCCESS) {
    dataTambahan = parseDataTambahan(res[6].data.data, tab, defaultAdminFjb);
  }

  if (res[7].ok && res[7].data.status === HttpStatus.SUCCESS) {
    dataKeterangan = {
      keterangan: res[7].data.data?.keterangan,
    };
  }

  data = {
    ...header,
    dataUnit,
    dataPemilik,
    dataPembawa,
    dataAnalisa,
    dataTransaksi,
    dataTambahan,
    dataKeterangan,
  };

  return {
    data,
    error,
  };
};
